const personnelWorkHour = {
  state: {
    productionLine: [],
    outsourcer: [],
    operator: [],
  },
  mutations: {
    SET_RPODUCTIONLINE: (state, productionLine) => {
      state.productionLine = productionLine;
    },
    SET_OUTSOURCER: (state, outsourcer) => {
      state.outsourcer = outsourcer;
    },
  },
};

export default personnelWorkHour;
